import MeContainer from "./MeContainer";
import AdminButton from "./AdminButton";
import { Box } from "@mui/material";

function HeaderRightRegion() {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
            }}
        >
            <AdminButton />
            <MeContainer />
        </Box>
    );
}

export default HeaderRightRegion;
